import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import CustomImg from "../Assets/img/custom_section.webp";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Je_welryspelling } from "../../../../Helpers/request";
import { useTranslation } from 'react-i18next'
import LocalizedLink from "../../../../Components/LocalizedLink";
const CustomDesign = () => {
 const { t } = useTranslation()
  return (
    <section className="custom-design">
      <Container fluid className="home-showcase-container">
        <Row className="align-items-center">
          <Col md={6} xs={12} className="text-center">
            <Image src={CustomImg}  loading="lazy" alt="Custom Design Jewelry " className="img-fluid" />
          </Col>

          <Col md={6} xs={12}>
            <Heading>
              <span>{t('customDesign.heading')}</span>
              <h2>{t('customDesign.subheading')}</h2>
              <p>
               {t('customDesign.subheading2')}

              </p>
            </Heading>

            <div className="text-center">
              <LocalizedLink to="/custom-design">
                <button className="golden-btn mx-auto">
                  {t('customDesign.button')}
                </button>
              </LocalizedLink>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomDesign;
